import React, { useEffect, useRef, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  $getSelection,
  $isElementNode,
  $isParagraphNode,
  $isRangeSelection,
  $isTextNode,
  ParagraphNode,
} from 'lexical';

import {
  $createTableNode,
  $createTableNodeWithDimensions,
  $createTableRowNode,
  $findCellNode,
  $findTableNode,
  $isTableNode,
  $isTableRowNode,
  TableCellNode,
  TableNode,
  TableRowNode,
} from '../nodes/CustomTableNode/src'; // adjust your import paths here
import { $generateNodesFromDOM } from '@lexical/html';
import { ImageNode } from '../nodes/ImageNode';
import { $getPageRoot, $isLayoutContainerNode } from '../nodes/LayoutContainerNode';
import { $createListItemNode, $createListNode } from '@lexical/list';
import { $createHeadingNode } from '../nodes/Heading-node-custom';

// export function createNodeFromType(type: string, options: any = {}) {
//   switch (type) {
//     case "paragraph":
//       return $createParagraphNode();

//     case "heading": {
//       const tag = options.__tag || "h1"; // default fallback
//       return $createHeadingNode(tag);
//     }

//     case "listitem": {
//       const listType = options.__listType || "bullet"; // "bullet" | "number"
//       return $createListNode(listType);
//     }

//     case "list": {
//       const listType = options.__listType || "bullet";
//       return $createListNode(listType);
//     }

//     default:
//       console.warn("Unknown nodeType:", type, " — defaulting to paragraph");
//       return $createParagraphNode();
//   }
// }

export   const findTables = (cell: TableCellNode, tables: TableNode[]) => {
    let arr: any[] = [];
    const parent = cell.getParent();
    if ($isTableRowNode(parent)) {
      const tableNode = parent.getParent();
      if ($isTableNode(tableNode)) {
        tables.forEach((table) => {
          if (tableNode.getGroupId() === table.getGroupId()) {
            arr.push(table)
          }
        })
      }

    }
    return arr
  }

// export function TableCellCharacterCountPlugin() {
//   const [editor] = useLexicalComposerContext();
//   const insertionDoneRef = useRef(false);

// const lastCellKeyRef = useRef<string | null>(null);

//   // useEffect(() => {
//   //   return editor.registerUpdateListener(({ editorState }) => {
//   //     editorState.read(() => {
//   //       const selection = $getSelection();
//   //       if (!$isRangeSelection(selection)) return;

//   //       const anchorNode = selection.anchor.getNode();
//   //       const cell = $findCellNode(anchorNode);

//   //       if (cell && cell.getTextContent().length >= 250) {
//   //         const cellKey = cell.getKey();
//   //         const text1 = cell.getTextContent();
//   //         const children = cell.getChildren()

//   //         if (lastCellKeyRef.current !== cellKey && text1.length >= 250 && children.length < 2) {
//   //           lastCellKeyRef.current = cellKey;
//   //            let splitted = false
//   //         const children = cell.getChildren();
//   //         const table = $findTableNode(cell)
//   //         const rowNode: TableRowNode | null = cell.getParent();
//   //         const nextTable: TableNode | null | undefined = table?.getNextSibling();
//   //         if (cell.getTextContent().length >= 250) {
//   //           splitted = true
//   //           const child = children[children.length -1]
//   //           const childType = children[children.length -1].getType();
//   //           editor.update(() => {
//   //             const paragraph = createNodeFromType(childType,children[children.length -1]);
//   //             const mid = Math.floor(text1.length / 2);

//   //             const part1 = text1.slice(0, mid);
//   //             const part2 = text1.slice(mid);  

//   //             const splitedChild = child.getTextContent().slice(child.getTextContent().length / 2)
//   //             const textNode = $createTextNode(part2)
//   //             paragraph.append(textNode)
//   //             table?.insertAfter(paragraph)
//   //             if($isTableNode(nextTable)){
//   //               const nextRow = nextTable.getFirstChild();
//   //               if($isTableRowNode(nextRow)){
//   //                 const currCellIndex = cell.getCellIndex()
//   //                 const cellToInsert = nextRow.getCellAtIndex(currCellIndex)
//   //                 if(cellToInsert){
//   //                   const firstChild = cellToInsert.getFirstChild();
//   //                   if(firstChild){
//   //                     firstChild.insertBefore(paragraph)
//   //                     const node = createNodeFromType(childType,children[children.length -1])
//   //                     const textnode = $createTextNode(part1)
//   //                     node.append(textnode)
//   //                     children[children.length -1].replace(node)
//   //                     firstChild.selectEnd()
//   //                   }else{
//   //                     cellToInsert.append(paragraph)
//   //                                           const node = createNodeFromType(childType,children[children.length-1])
//   //                     const textnode = $createTextNode(part1)
//   //                     node.append(textnode)
//   //                     children[children.length -1].replace(node)
//   //                     cellToInsert.select()
//   //                   }
//   //                 }
//   //               }
//   //             }
//   //             if(!$isTableNode(nextTable) && rowNode && table){
//   //               const newTable = $createTableNodeWithDimensions(1,rowNode?.getChildren().length,false);
//   //               newTable.setGroupId(table.getGroupId())
//   //               newTable.setIsCaption(false);
//   //               table?.insertAfter(newTable);
//   //               const newRow = newTable.getFirstChild();
//   //               if($isTableRowNode(newRow)){
//   //                 const CellToInsert = newRow.getCellAtIndex(cell.getCellIndex());
//   //                 if(CellToInsert){
//   //                   const firstChild = CellToInsert.getFirstChild();
//   //                   if(firstChild){
//   //                     firstChild.insertBefore(paragraph);
//   //                     const node = createNodeFromType(childType,children[children.length -1])
//   //                     const textnode = $createTextNode(part1)
//   //                     node.append(textnode)
//   //                     children[children.length-1].replace(node)
//   //                     firstChild.selectEnd()
//   //                   }
//   //                   else{
//   //                     CellToInsert.append(paragraph)
//   //                     const node = createNodeFromType(childType)
//   //                     const textnode = $createTextNode(part1)
//   //                     node.append(textnode)
//   //                     children[children.length -1].replace(node)
//   //                     CellToInsert.select()
//   //                   }
//   //                 }
//   //               }
//   //             }
//   //           })
//   //         }


//   //         }
//   //       }
//   //     });
//   //   });
//   // }, [editor]);

  


//   useEffect(() => {
//     return editor.registerUpdateListener(({ editorState }) => {
//       editorState.read(() => {
//         const selection = $getSelection();
//         if (!$isRangeSelection(selection)) {
//           insertionDoneRef.current = false;
//           return;
//         }

//         const anchorNode = selection.anchor.getNode();
//         const cell = $findCellNode(anchorNode);

//         if (cell && cell.getTextContent().length >= 250 && cell.getChildren().length >=2) {
//           const children = cell.getChildren();
//           editor.update(() => {
//             const table = $findTableNode(cell)
//             const rowNode: TableRowNode | null = cell.getParent();
//             if (cell.getTextContent().length >= 250 && children.length >= 2) {
//               const childToPush = children[children.length -1]
//               const nextTable: TableNode | null | undefined = table?.getNextSibling();
//               if (rowNode && !$isTableNode(nextTable) && table) {
//                 const cellLength = rowNode.getChildren().length;
//                 const tableNode = $createTableNodeWithDimensions(1, cellLength, false);
//                 tableNode.setGroupId(table.getGroupId())
//                 tableNode.setIsCaption(false)
//                 table?.insertAfter(tableNode)
//                 const row: TableRowNode | null = tableNode.getFirstChild();
//                 if (row) {
//                   const cellTOpush = row.getCellAtIndex(cell.getCellIndex())
//                   if (cellTOpush) {
//                     const firstChild = cellTOpush.getFirstChild();
//                     if (firstChild) {
//                       firstChild.insertBefore(childToPush)
//                       return
//                     } else {
//                       cellTOpush.append(childToPush)
//                       return
//                     }
//                   }

//                 }
//               }
//               if ($isTableNode(nextTable)) {

//                 const firstRow: TableRowNode | null = nextTable.getFirstChild()
//                 if (!firstRow) return
//                 const cell2 = firstRow.getCellAtIndex(cell.getCellIndex())
//                 if (!cell2) return;
//                 const firstChild = cell2.getFirstChild()
//                 if (firstChild) {
//                   firstChild.insertBefore(childToPush)
//                 } else {
//                   cell2?.append(childToPush)
//                 }
//               }
//             }
//           })
//         }
//       });
//     });
//   }, [editor]);

//   return null;
// }
